import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { EntityViewLayout } from "../entityLayout/entityViewLayout";
import {
  getAllReviewsCoach,
  updateReviewCoach,
} from "../../store/reviews/reviewActions";

export const ShowCoachesReviews = () => {
  const rev = useSelector((state) => state.rev);
  const { isLodaing } = useSelector((state) => state.errors);
  const dispatch = useDispatch();

  const tableProps = {
    name: "Coach Reviews",
    routePath: "/reviews/admin-coaches",
    addNewText: "Add new coach review",
    isBreadcrumbs: true,
    isAddNew: false,
    isSearch: true,
    isFilters: false,
    isDateFilters: false,
    isTimeFilters: false,
    isPriceFilter: false,
    isCsvConvert: false,
    isExcelConvert: false,
    columns: [
      {
        Header: "S.No",
        id: "row",
        type: "index",
        maxWidth: 75,
        filterable: false,
      },
      {
        Header: "Member Name",
        accessor: "user.first_name",
        paddingTop: "35px",
      },
      {
        Header: "Member Reviews",
        accessor: "description",
        paddingTop: "35px",
      },
      {
        Header: "Gym Name",
        accessor: "coach.gym.name",
        paddingTop: "35px",
      },
      {
        Header: "Coach Name",
        accessor: "coach.name",
        paddingTop: "35px",
      },
      {
        Header: "Rating",
        id: "row_star",
        type: "rating",
        accessor: "rating",
        maxWidth: 150,
        filterable: false,
      },

      {
        Header: "Action",
        maxWidth: 350,
        type: "actions",
        isViewButton: true,
        isStatusButton: true,
      },
    ],
  };

  const searchFields = ["class", "description"];
  let history = useHistory();

  const updateItem = (is_active, id) => {
    dispatch(updateReviewCoach(is_active, id));
  };

  useEffect(() => {
    dispatch(getAllReviewsCoach());
  }, []);

  return (
    <EntityViewLayout
      isLoading={isLodaing}
      items={rev.coachreviews}
      searchFields={searchFields}
      tableProps={tableProps}
      history={history}
      updateItem={updateItem}
    />
  );
};
